// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.name {
    font-size: 2em;
    font-weight: 900;
    margin-bottom: 5%;
}
.intro {
    padding: 10%;
    /* margin-left: 15%;
    margin-top: 5%; */
}
@media only screen and (min-width: 992px){
    .profile-picture {
        border-radius: 50%;
        margin-top: 0;
        margin-bottom: 20px;
        height: 200px;
        width: 200px;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10%;
    }
}

.profile-picture img {
    display: block;
}
.email a, p a {
    text-decoration: none;
    color: inherit;
    border-bottom: dotted 1px rgba(160, 160, 160, 0.65);
    text-transform: uppercase;
}

.email a:hover, p a:hover  {
    text-decoration: none;
    color: inherit;
    font-weight: 500;
}

.main-hr {
    margin-top: 15%;
    margin-bottom: 15%;
}
hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #ccc;
    margin: 1em 0;
    padding: 0;
}

#footer .icons{
    color: #aaaaaa;
}

ul.icons {
    cursor: default;
    list-style: none;
    padding-left: 0;
}

ul.icons li {
    display: inline-block;
    padding: 0 1em 0 0;
    font-size: 1.7em;
}

ul.icons li > * {
    text-decoration: none;
    border: 0;
    color: black;
}

#footer .copyright {
    color: #aaaaaa;
    font-family: "Raleway", Helvetica, sans-serif;
    font-size: 0.5em;
    font-weight: 400;
    letter-spacing: 0.25em;
    text-transform: uppercase;
}
`, "",{"version":3,"sources":["webpack://./src/components/Intro/Intro.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ;qBACiB;AACrB;AACA;IACI;QACI,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,aAAa;QACb,YAAY;QACZ,gBAAgB;QAChB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,kBAAkB;IACtB;AACJ;;AAEA;IACI,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,cAAc;IACd,mDAAmD;IACnD,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,WAAW;IACX,SAAS;IACT,0BAA0B;IAC1B,aAAa;IACb,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,6CAA6C;IAC7C,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B","sourcesContent":[".name {\n    font-size: 2em;\n    font-weight: 900;\n    margin-bottom: 5%;\n}\n.intro {\n    padding: 10%;\n    /* margin-left: 15%;\n    margin-top: 5%; */\n}\n@media only screen and (min-width: 992px){\n    .profile-picture {\n        border-radius: 50%;\n        margin-top: 0;\n        margin-bottom: 20px;\n        height: 200px;\n        width: 200px;\n        overflow: hidden;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin-bottom: 10%;\n    }\n}\n\n.profile-picture img {\n    display: block;\n}\n.email a, p a {\n    text-decoration: none;\n    color: inherit;\n    border-bottom: dotted 1px rgba(160, 160, 160, 0.65);\n    text-transform: uppercase;\n}\n\n.email a:hover, p a:hover  {\n    text-decoration: none;\n    color: inherit;\n    font-weight: 500;\n}\n\n.main-hr {\n    margin-top: 15%;\n    margin-bottom: 15%;\n}\nhr {\n    display: block;\n    height: 1px;\n    border: 0;\n    border-top: 1px solid #ccc;\n    margin: 1em 0;\n    padding: 0;\n}\n\n#footer .icons{\n    color: #aaaaaa;\n}\n\nul.icons {\n    cursor: default;\n    list-style: none;\n    padding-left: 0;\n}\n\nul.icons li {\n    display: inline-block;\n    padding: 0 1em 0 0;\n    font-size: 1.7em;\n}\n\nul.icons li > * {\n    text-decoration: none;\n    border: 0;\n    color: black;\n}\n\n#footer .copyright {\n    color: #aaaaaa;\n    font-family: \"Raleway\", Helvetica, sans-serif;\n    font-size: 0.5em;\n    font-weight: 400;\n    letter-spacing: 0.25em;\n    text-transform: uppercase;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
